import { render } from "./Home.vue?vue&type=template&id=be3675fa&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=be3675fa&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-be3675fa"

export default script